import { Node_Type } from "./../ricos-types";
import { createRicosFunctionalExtension } from "./../plugin-commons";
const lineSpacing = createRicosFunctionalExtension({
  type: "extension",
  groups: [],
  name: "lineSpacing",
  reconfigure(config, _extensions) {
    const types = [
      Node_Type.PARAGRAPH,
      Node_Type.HEADING,
      Node_Type.CODE_BLOCK,
      Node_Type.BLOCKQUOTE,
      Node_Type.CAPTION
    ];
    return {
      ...config,
      addGlobalAttributes() {
        return [
          {
            types,
            attributes: {
              textStyle: {
                renderHTML: (attributes) => {
                  const styles = [];
                  if (!isNaN(attributes?.textStyle?.lineHeight)) {
                    styles.push(`line-height:${attributes.textStyle.lineHeight}`);
                  }
                  return {
                    style: styles.join(";")
                  };
                }
              }
            }
          },
          {
            types,
            attributes: {
              style: {
                renderHTML: (attributes) => {
                  const styles = [];
                  if (attributes?.style?.paddingTop) {
                    styles.push(`padding-top:${attributes.style.paddingTop}`);
                  }
                  if (attributes?.style?.paddingBottom) {
                    styles.push(`padding-bottom:${attributes.style.paddingBottom}`);
                  }
                  return {
                    style: styles.join(";")
                  };
                }
              }
            }
          }
        ];
      },
      addCommands() {
        return {
          setLineSpacings: (lineSpacings) => ({ chain }) => {
            const {
              "line-height": stringLineHeight,
              "padding-bottom": stringPaddingBottom,
              "padding-top": stringPaddingTop
            } = lineSpacings;
            const lineHeight = parseFloat(stringLineHeight);
            const paddingBottom = parseFloat(stringPaddingBottom);
            const paddingTop = parseFloat(stringPaddingTop);
            return chain().focus().setLineSpacing(lineHeight).setLineSpacingBefore(paddingTop).setLineSpacingAfter(paddingBottom).run();
          },
          setLineSpacing: (lineSpacing2) => ({ commands }) => {
            if (lineSpacing2 > 100 || lineSpacing2 < 0) {
              return false;
            }
            return types.map(
              (type) => commands.updateAttributesWithDeepMerge(type, {
                textStyle: { lineHeight: lineSpacing2 }
              })
            ).every(Boolean);
          },
          setLineSpacingBefore: (lineSpacing2) => ({ commands }) => {
            if (lineSpacing2 > 100 || lineSpacing2 < 0) {
              return false;
            }
            return types.map(
              (type) => commands.updateAttributesWithDeepMerge(type, {
                style: {
                  paddingTop: `${lineSpacing2}px`
                }
              })
            ).every(Boolean);
          },
          setLineSpacingAfter: (lineSpacing2) => ({ commands }) => {
            if (lineSpacing2 > 100 || lineSpacing2 < 0) {
              return false;
            }
            return types.map(
              (type) => commands.updateAttributesWithDeepMerge(type, {
                style: {
                  paddingBottom: `${lineSpacing2}px`
                }
              })
            ).every(Boolean);
          }
        };
      }
    };
  },
  createExtensionConfig() {
    return {
      name: this.name
    };
  }
});
export {
  lineSpacing
};
//# sourceMappingURL=tiptap.js.map
